import { gsap } from "gsap";
export class TagsGroup {
  constructor(element, config = {}) {
    this.element = element;
    this.items = element.querySelectorAll('[data-tags-group-item]');

    const defaultConfig = {
      staggerDelay: 0.2,        // Delay between each item animation
      rotationDuration: 1.4,    // Duration of rotation animation
      opacityDuration: 0.5,     // Duration of opacity animation
      startRotation: -25,       // Starting rotation angle
      intersectionThreshold: 0.2,
      intersectionRootMargin: '50px'
    };

    this.config = { ...defaultConfig, ...config };
    this.hasAnimated = false;

    // Initialize items
    this.initializeItems();

    // Setup intersection observer
    this.setupIntersectionObserver();

    // Add initialized class to show the group
    this.element.classList.add('initialized');
  }

  initializeItems() {
    // Set initial state for all items using GSAP
    gsap.set(this.items, {
      opacity: 0,
      rotation: this.config.startRotation
    });
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: this.config.intersectionRootMargin,
      threshold: this.config.intersectionThreshold
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.animate();
          this.hasAnimated = true;
          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this.element);
  }

  animate() {
    // Create timeline for coordinated animations
    const tl = gsap.timeline();

    // Animate items with stagger
    tl.to(this.items, {
      opacity: 1,
      duration: this.config.opacityDuration,
      stagger: this.config.staggerDelay
    })
      .to(this.items, {
        rotation: 0,
        duration: this.config.rotationDuration,
        stagger: this.config.staggerDelay,
        ease: "elastic.out(1, 0.3)", // Swing effect
      }, "<"); // Start at the same time as opacity
  }

  dispose() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.observer = null;
    this.element = null;
    this.items = null;
  }
}
